import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAppId } from "../../context/AppIdContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../component/header';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const VolunteerWiseSlipSendDash = () => {
    // --- Context & State ---
    const { appId, language } = useAppId();
    const [loading, setLoading] = useState(true);
    const [volunteers, setVolunteers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    
    // --- Summary State ---
    const [summary, setSummary] = useState({
        totalVolunteers: 0,
        totalSlipsSent: 0
    });

    const lang = language || 'en';

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "Volunteer Wise Slip Status",
            pageSubtitle: "Track slip distribution performance across all volunteers.",
            searchPlaceholder: "Search by name or mobile...",
            totalVolunteers: "Total Volunteers",
            totalSlips: "Total Slips Sent",
            slipsSent: "Slips Sent",
            noRecordsFound: "No volunteers found matching",
            loading: "Loading Volunteer Data...",
            admin: "Admin",
            subAdmin: "Sub Admin",
            volunteer: "Volunteer",
            boothPramukh: "Booth Pramukh",
            sakti:"Sakti Kendra Pramukh"
        },
        hi: {
            pageTitle: "कार्यकर्ता वार पर्ची स्थिति",
            pageSubtitle: "सभी कार्यकर्ताओं के पर्ची वितरण प्रदर्शन को ट्रैक करें।",
            searchPlaceholder: "नाम या मोबाइल से खोजें...",
            totalVolunteers: "कुल कार्यकर्ता",
            totalSlips: "कुल भेजी गई पर्चियां",
            slipsSent: "पर्ची भेजी गई",
            noRecordsFound: "कोई कार्यकर्ता नहीं मिला",
            loading: "डेटा लोड हो रहा है...",
            admin: "एडमिन",
            subAdmin: "सब एडमिन",
            volunteer: "कार्यकर्ता",
            boothPramukh: "बूथ प्रमुख"
        },
        gu: {
            pageTitle: "કાર્યકર્તા મુજબ સ્લિપ સ્ટેટસ",
            pageSubtitle: "તમામ સ્વયંસેવકોમાં સ્લિપ વિતરણ પ્રદર્શનને ટ્રૅક કરો.",
            searchPlaceholder: "નામ અથવા મોબાઇલથી શોધો...",
            totalVolunteers: "કુલ કાર્યકર્તાઓ",
            totalSlips: "કુલ મોકલેલ સ્લિપ",
            slipsSent: "મોકલેલ સ્લિપ",
            noRecordsFound: "કોઈ કાર્યકર્તા મળ્યો નથી",
            loading: "ડેટા લોડ થઈ રહ્યો છે...",
            admin: "એડમિન",
            subAdmin: "સબ એડમિન",
            volunteer: "કાર્યકર્તા",
            boothPramukh: "બૂથ પ્રમુખ"
        }
    };

    const txt = t[lang] || t['en'];

    // Helper for User Types
    const getUserTypeLabel = (type) => {
        const map = {
            'A': txt.admin,
            'SA': txt.subAdmin,
            'sa': txt.subAdmin,
            'K': txt.volunteer,
            'k': txt.volunteer,
            'BP': txt.boothPramukh,
            'SP':txt.sakti
        };
        return map[type] || type || 'User';
    };

     const navigate = useNavigate(); // --- ADDED NAVIGATE HOOK ---

    // --- Fetch Data ---
    useEffect(() => {
        if (appId) {
            fetchVolunteerData();
        } else {
            setLoading(false);
        }
    }, [appId]);

    const fetchVolunteerData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_user_wise_slip_distribution`, {
                app_id: appId
            });

            if (response.data.success && response.data.data && response.data.data.Success === "1") {
                const data = response.data.data.result || [];
                setVolunteers(data);
                
                // Calculate Summary
                const totalSent = data.reduce((sum, user) => sum + (user.total || 0), 0);
                setSummary({
                    totalVolunteers: data.length,
                    totalSlipsSent: totalSent
                });
            } else {
                setVolunteers([]);
            }
        } catch (error) {
            console.error("Error fetching volunteer slip data:", error);
            setVolunteers([]);
        } finally {
            setLoading(false);
        }
    };
    console.log(volunteers)


    
    // --- Filter Logic ---
    const filteredVolunteers = volunteers.filter(user => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();
        return (
            (user.name && user.name.toLowerCase().includes(lowerSearch)) ||
            (user.mobile_no && String(user.mobile_no).includes(lowerSearch))
        );
    });

    if (loading) {
        return (
            <div className="loader-wrapper">
                <div className="spinner"></div>
                <p className="loader-text">{txt.loading}</p>
                <style jsx>{`
                    .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 100vh; width: 100%; background: #F4F5F8; }
                    .spinner { width: 50px; height: 50px; border: 4px solid #F1F5F9; border-top: 4px solid #8B5CF6; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; }
                    .loader-text { color: #64748B; font-weight: 500; font-size: 1.1rem; }
                    @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                `}</style>
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            {/* Header */}
            <div className="dashboard-header-wrapper">
                <Header title={txt.pageTitle} />
            </div>

            <main className="dashboard-main">
                {/* --- Search & Filter --- */}
                <div className="search-section slide-up-element" style={{ animationDelay: '0.15s' }}>
                    <div className="search-wrapper">
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="count-display-modern slide-up-element">
                        <span className="count-label">{lang === 'en' ? 'Total :' : (lang === 'hi' ? 'कुल :' : 'કુલ :')}</span>
                        <span className="count-number">{filteredVolunteers.length}</span>
                    </div>
                </div>

                {/* --- Grid of Volunteer Cards --- */}
                <div className="volunteer-grid">
                    {filteredVolunteers.length > 0 ? (
                        filteredVolunteers.map((user, index) => {
                            // Fix duplicate HTTP issues in photo_path if present from bad DB entries
                            let safePhotoPath = user.photo_path;
                            if (safePhotoPath && safePhotoPath.includes('http') && safePhotoPath.lastIndexOf('http') > 0) {
                                safePhotoPath = safePhotoPath.substring(safePhotoPath.lastIndexOf('http'));
                            }

                            return (
                                <div className="modern-user-card slide-up-element" style={{ animationDelay: `${0.1 * (index % 5)}s` }} key={user.user_id || index} onClick={()=> navigate('/volunteers_slip_send_voters',{state:{user_id:user.user_id}})}>
                                    <div className="card-top-section">
                                        <div className="user-avatar-wrapper">
                                            <img 
                                                src={safePhotoPath || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=ffffff&color=8B5CF6`} 
                                                onError={(e) => {
                                                    e.target.onerror = null; 
                                                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=ffffff&color=8B5CF6`;
                                                }}
                                                alt={user.name} 
                                                className="user-avatar-img"
                                            />
                                        </div>
                                        <div className="user-info">
                                            <h3 className="user-name" title={user.name}>{user.name}</h3>
                                            <div className="user-contact">
                                                <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="phone-icon">
                                                    <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                </svg>
                                                {user.mobile_no || 'N/A'}
                                            </div>
                                            <span className="badge">{getUserTypeLabel(user.user_type)}</span>
                                        </div>
                                    </div>

                                    <div className="card-bottom-section">
                                        <div className="stat-box">
                                            <span className="stat-label">{txt.slipsSent}</span>
                                            <span className="stat-value">{user.total.toLocaleString()}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-results">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="1.5">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            <p>{txt.noRecordsFound} "{searchTerm}"</p>
                        </div>
                    )}
                </div>
            </main>

            <style jsx>{`
                /* --- KEYFRAMES --- */
                @keyframes slideInUp {
                    from { opacity: 0; transform: translateY(15px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                /* --- GLOBAL STRUCTURE --- */
                .dashboard-container {
                    background: #E5E7EB;
                    min-height: 100vh;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                    width: 100%;
                    box-sizing: border-box;
                }
                
                .dashboard-container * {
                    box-sizing: border-box;
                }

                .slide-up-element {
                    opacity: 0;
                    animation: slideInUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
                }

                /* Header Wrapper */
                .dashboard-header-wrapper {
                    padding: 16px 20px;
                }
                @media (min-width: 768px) {
                    .dashboard-header-wrapper { padding: 25px 25px 0 25px; }
                }

                /* Dashboard Main */
                .dashboard-main {
                    padding: 12px 16px;
                    max-width: 100%;
                    margin: 0 auto;
                }
                @media (min-width: 768px) {
                    .dashboard-main { padding: 16px 24px; }
                }

                .page-subtitle {
                    font-size: 1.05rem;
                    font-weight: 700;
                    color: #475569;
                    margin: 0 0 20px 0;
                }

                /* --- SUMMARY CARDS --- */
                .summary-section {
                    margin-bottom: 24px;
                }

                .summary-cards {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 16px;
                }

                .summary-card {
                    background: #FFFFFF;
                    border-radius: 20px;
                    padding: 24px;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
                    border: 1px solid #F1F5F9;
                    transition: all 0.3s ease;
                }

                .summary-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 24px rgba(139, 92, 246, 0.08);
                }

                .card-icon {
                    width: 64px;
                    height: 64px;
                    border-radius: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                }

                .blue-gradient { background: linear-gradient(135deg, #3B82F6, #2563EB); }
                .purple-gradient { background: linear-gradient(135deg, #A78BFA, #8B5CF6); }

                .card-content {
                    display: flex;
                    flex-direction: column;
                }

                .card-label {
                    font-size: 0.8rem;
                    font-weight: 600;
                    color: #64748B;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 4px;
                }

                .card-value {
                    font-size: 1.8rem;
                    font-weight: 800;
                    line-height: 1.1;
                }

                .text-slate { color: #1E293B; }
                .text-purple { color: #8B5CF6; }

                /* --- SEARCH SECTION --- */
                .search-section {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 16px;
                    margin-bottom: 24px;
                }

                .search-wrapper {
                    position: relative;
                    flex: 1;
                    max-width: 450px;
                }

                .search-icon {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 18px;
                    height: 18px;
                    color: #9CA3AF;
                }

                .search-input {
                    width: 100%;
                    padding: 14px 16px 14px 44px;
                    border: 1px solid #E2E8F0;
                    border-radius: 14px;
                    font-size: 0.95rem;
                    outline: none;
                    transition: all 0.2s ease;
                    background: #FFFFFF;
                    color: #1E293B;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
                }

                .search-input:focus {
                    border-color: #8B5CF6;
                    box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.1);
                }

                /* --- COUNT DISPLAY --- */
                .count-display-modern { display: inline-flex; align-items: center; background: #eff6ff; padding: 8px 16px; border-radius: 12px; border: 1px solid #bfdbfe; box-shadow: 0 2px 4px rgba(37, 99, 235, 0.05); gap: 8px; }
                .count-label { color: #1e40af; font-weight: 600; font-size: 15px; }
                .count-number { background: transparent; color: #1d4ed8; font-weight: 800; font-size: 16px; }

                /* --- VOLUNTEER CARDS GRID --- */
                .volunteer-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
                    gap: 20px;
                }

                .modern-user-card {
                    background: #FFFFFF;
                    border-radius: 20px;
                    padding: 24px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
                    border: 1px solid #F1F5F9;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                }

                .modern-user-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 24px -5px rgba(139, 92, 246, 0.1);
                    border-color: #E2E8F0;
                }

                /* Card Top Section (Avatar & Info) */
                .card-top-section {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                }

                .user-avatar-wrapper {
                    position: relative;
                    flex-shrink: 0;
                }

                .user-avatar-img {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 2px solid #F1F5F9;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                }

                .user-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                }

                .user-name {
                    font-size: 1.1rem;
                    font-weight: 800;
                    color: #1E293B;
                    margin: 0 0 4px 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .user-contact {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 0.85rem;
                    font-weight: 500;
                    color: #64748B;
                    margin-bottom: 8px;
                }

                .badge {
                    align-self: flex-start;
                    font-size: 0.7rem;
                    font-weight: 700;
                    color: #8B5CF6;
                    background: #F3E8FF;
                    padding: 4px 10px;
                    border-radius: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                /* Card Bottom Section (Stats) */
                .card-bottom-section {
                    padding-top: 20px;
                    border-top: 1px dashed #E2E8F0;
                }

                .stat-box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: #F8FAFC;
                    padding: 12px 16px;
                    border-radius: 14px;
                }

                .stat-label {
                    font-size: 0.85rem;
                    font-weight: 600;
                    color: #475569;
                }

                .stat-value {
                    font-size: 1.4rem;
                    font-weight: 800;
                    color: #8B5CF6;
                }

                /* No Results */
                .no-results {
                    grid-column: 1 / -1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 60px 20px;
                    color: #64748B;
                    text-align: center;
                    background: #FFFFFF;
                    border-radius: 20px;
                    border: 1px dashed #CBD5E1;
                }

                .no-results svg {
                    margin-bottom: 16px;
                    opacity: 0.5;
                }

                .no-results p {
                    margin: 0;
                    font-size: 1rem;
                    font-weight: 500;
                }

                /* Mobile Adjustments */
                @media (max-width: 640px) {
                    .search-section {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .search-wrapper {
                        max-width: 100%;
                    }
                    .result-count {
                        text-align: center;
                    }
                    .volunteer-grid {
                        grid-template-columns: 1fr;
                    }
                }
            `}</style>
        </div>
    );
};

export default VolunteerWiseSlipSendDash;